
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import RoundSelect from '@/components/molecules/RoundSelect.vue'
import ButtonDownload from '@/components/molecules/ButtonDownload.vue'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import StudentPersonalProgressPanel from '@/components/organisms/manage/StudentPersonalProgressPanel.vue'
import LearningProgressTip from '@/components/organisms/LearningProgressTip.vue'
import { LearningProgressList } from '@/models/manage/LearningProgressList'
import { SelectItem } from '@/models/SelectItem'
import { LearningProgress } from '@/const/LearningProgress'

/**
 * 生徒毎の教材別学習進捗確認
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
    RoundSelect,
    ButtonDownload,
    ManageSidemenuLayout,
    StudentPersonalProgressPanel,
    LearningProgressTip,
  },
})
export default class StudentPersonalStudyCategoryProgress extends Vue {
  /** 学年フィルター */
  @Ref()
  gradeFilter!: RoundSelect

  /** 教科フィルター */
  @Ref()
  subjectFilter!: RoundSelect

  /** 教材フィルター */
  @Ref()
  studyCategoryFilter!: RoundSelect

  /** 塾管理者権限画面の場合true */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** 先生権限画面の場合true */
  @Prop({ default: false })
  private isTeacher!: boolean

  /** 生徒ニックネーム */
  @Prop()
  private studentName!: string

  /** 学年フィルターの選択肢 */
  @Prop()
  private filterGradeList!: SelectItem[]

  /** 教科フィルターの選択肢 */
  @Prop()
  private filterSubjectList!: SelectItem[]

  /** 教科フィルターの初期値 */
  @Prop()
  private defaultSubjectCode!: string

  /** 教材フィルターの選択肢 */
  @Prop()
  private filterStudyCategoryList!: SelectItem[]

  /** 単元一覧 */
  @Prop()
  private progressCurriculumUnits!: LearningProgressList.CurriculumUnit[]

  /** 生徒学習進捗タブの状態: trueならactive */
  @Prop({ default: false })
  private isStudentProgressTabActive!: boolean

  /** 知識MAPタブの状態: trueならactive */
  @Prop({ default: false })
  private isKnowledgeMapTabActive!: boolean

  /** 教材選択ボタンのDisabled制御 */
  @Prop()
  private isDisabledSelectStudyCategory!: boolean

  /** 生徒学習進捗タブクリック時のイベント */
  @Prop()
  private eventClickStudentProgressTab?: () => void

  /** 知識MAPタブクリック時のイベント */
  @Prop()
  private eventClickKnowledgeMapTab?: () => void

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventClickBackButton!: () => void

  /** 学年フィルター変更時のイベント */
  @Prop()
  private changeGradeFilter!: () => void

  /** 教科フィルター変更時のイベント */
  @Prop()
  private changeSubjectFilter!: () => void

  /** 教材フィルター変更時のイベント */
  @Prop()
  private changeStudyCategoryFilter!: () => void

  /** ダウンロードボタン押下時のイベント */
  @Prop()
  private eventClickDownload!: () => void

  /**
   * 単元情報テーブルの表示制御
   *
   * @returns 単元情報がなければtrue(替わりのメッセージを表示)
   */
  private get isEmptyCurriculumUnits(): boolean {
    return this.progressCurriculumUnits.length === 0
  }

  /**
   * 選択中の学年コード取得
   *
   * @returns 選択中の学年コード
   */
  public selectedGradeCode(): string {
    return this.gradeFilter.selectedValue()
  }

  /**
   * 学年選択の選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentGradeCode(value: string): void {
    this.gradeFilter.setCurrentValue(value)
  }

  /**
   * 選択中の教科コード取得
   *
   * @returns 選択中の教科コード
   */
  public selectedSubjectCode(): string {
    return this.subjectFilter.selectedValue()
  }

  /**
   * 教科選択の選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentSubjectCode(value: string): void {
    this.subjectFilter.setCurrentValue(value)
  }

  /**
   * 選択中の教材コード取得
   *
   * @returns 選択中の教材コード
   */
  public selectedStudyCategoryCode(): string {
    return this.studyCategoryFilter.selectedValue()
  }

  /**
   * 教材選択の選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentStudyCategoryCode(value: string): void {
    this.studyCategoryFilter.setCurrentValue(value)
  }

  /**
   * 学習進捗
   *
   * @param code 進捗コード
   * @returns 学習進捗マスター
   */
  private progress(code: string): LearningProgress.LearningProgressMaster {
    return LearningProgress.findByCode(code)
  }
}
